// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1Wqcw","errorLogs":"EditorFooter_errorLogs__1TFZB"};